import React from 'react';
import styled from 'styled-components';
import {
  collabData,
  decorData,
  inspirationData,
  newData,
  outdoorData,
  windowData,
  swatchesData,
  furnitureData,
  wallpaperData,
  beddingData,
  fabricData,
  tradeData
} from '../../common/helper';
import ImageModule from './ImageModule';
import NavHoveredMenu from './NavHoveredMenu';
import getImageUrl from "@/utils/images";
import useSale from '@/hooks/useSale';

const Wrapper = styled.div`
  margin-top: 1px;
  transition: all 0.15s ease-out;
  left: 0;
  position: absolute;
  width: 100%;
  background-color: white;
  z-index: 1;
  overflow: hidden;

  display: flex;
  justify-content: center;
  min-height: 0;
  max-height: 0;

  .single-item-dropdown {
    width: 100%;
    display: flex;

    .spacer {
      flex: 1 1 0px;
    }

    .collection-dropdown {
      min-width: 170px;
    }
    .collab-dropdown {
      min-width: 150px;
    }
  }

  &.active {
    transition: all 0.25s ease-in;
    min-height: 150px;
    max-height: 700px;
    padding-bottom: 30px;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    50% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
    }
  }

  .wrapper-head-menu {
    animation: fadeIn 0.3s ease-out;
    margin-top: 40px;
    display: flex;
    width: ${({ elementWidth }) => elementWidth};
    justify-content: space-between;
    padding: 0 20px;
    .hovered-menu {
      flex: initial 1 0px;
    }
  }
`;

/*

with images:
3 columns bedroom, living room, dining => 1000px
2 columns decor, new => 800px
1 columns new, collaborations, collections => 600px

*/

function FullHeadMenuDropdown({
                                itemsWithDropDown,
                                hoveredItem,
                                isSingleItems
                              }) {
  const getLength = () => {
    switch (hoveredItem) {
      case 'new':
        return newData.length;
      case 'furniture':
        return furnitureData.length;
      case 'decor':
        return decorData.length;
      case 'outdoor':
        return outdoorData.length;
      case 'window':
        return windowData.length;
      case 'wallpaper':
        return wallpaperData.length;
      case 'bedding':
        return beddingData.length;
      case 'fabric':
        return fabricData.length;
      case 'inspiration':
        return inspirationData.length;
      case 'collaborations':
        return collabData.length;
      case 'swatches':
        return swatchesData.length;
      case 'trade':
        return tradeData.length;
    }
  };

  const getWidth = () => {
    let length = getLength();
    if (length > 3) return '1240px';
    if (length > 2) return '1000px';
    if (length > 1) return '800px';
    return '600px';
  };

  const { isSale } = useSale();

  return (
    <Wrapper
      className={`dropdown-full-menu ${itemsWithDropDown ? 'active' : ''} `}
      isSingleItems={isSingleItems}
      elementWidth={getWidth()}
    >
      {itemsWithDropDown && (
        <>
          {hoveredItem === 'furniture' && (
            <div className="wrapper-head-menu">
              {furnitureData.map((item, i) => {
                if (item.sameColumn) {
                  return (
                    <CollapsedMenu items={item.subItems} />
                  )
                }

                return (
                  <NavHoveredMenu
                    className="hovered-menu"
                    key={i}
                    item={item}
                  />
                );
              })}
              <ImageModule
                copy="Your Sleep Sanctuary"
                image={getImageUrl('homepage/rebrand/kyliefitts_theinsideatkris.jpg')}
                url={`/collections/the-bedroom-edit`}
                customImgixParameters={{
                  crop: 'focalpoint',
                  'fp-x': 0.5,
                  'fp-y': 0.45,
                  'fp-z': 1,
                  ar: '1.7:1'
                }}
              />
            </div>
          )}
          {hoveredItem === 'decor' && (
            <div className="wrapper-head-menu">
              {decorData.map((item, i) => {
                return (
                  <NavHoveredMenu
                    className="hovered-menu"
                    key={i}
                    item={item}
                  />
                );
              })}
              <ImageModule
                copy="Pillow Talk"
                image={getImageUrl('homepage/rebrand/kyliefitts_theinside interiordefine_veronica-vinewayyy.jpg')}
                url="/c/home-decor/throw-pillows"
                customImgixParameters={{
                  crop: 'focalpoint',
                  'fp-y': 0.47,
                  ar: '1.7:1'
                }}
              />
            </div>
          )}

          {hoveredItem === 'window' && (
            <div className="wrapper-head-menu">
              {windowData.map((item, i) => {
                return (
                  <NavHoveredMenu
                    className="hovered-menu"
                    key={i}
                    item={item}
                  />
                );
              })}
              <ImageModule
                copy={isSale ? "20% off Curtains" : "Introducing: Curtains"}
                image={getImageUrl('homepage/rebrand/introducing_curtains.jpg')}
                url="/c/home-decor/curtains"
                customImgixParameters={{
                  crop: 'focalpoint',
                  'fp-y': 0.5,
                  ar: '1.7:1'
                }}
              />
            </div>
          )}
          {hoveredItem === 'bedding' && (
            <div className="wrapper-head-menu">
              {beddingData.map((item, i) => {
                return (
                  <NavHoveredMenu
                    className="hovered-menu"
                    key={i}
                    item={item}
                  />
                );
              })}
              <ImageModule
                copy={isSale ? "20% off Bedding" : "Cozy Up"}
                image={getImageUrl('homepage/rebrand/kyliefitts_theinside_december2024_danielles.jpg')}
                url="/collections/all-bedding"
                customImgixParameters={{
                  crop: 'focalpoint',
                  'fp-y': 0.5,
                  ar: '1.7:1'
                }}
              />
            </div>
          )}
          {/*{hoveredItem === 'wallpaper' && (*/}
          {/*  <div className="wrapper-head-menu">*/}
          {/*    {wallpaperData.map((item, i) => {*/}
          {/*      return (*/}
          {/*        <NavHoveredMenu*/}
          {/*          className="hovered-menu"*/}
          {/*          key={i}*/}
          {/*          item={item}*/}
          {/*        />*/}
          {/*      );*/}
          {/*    })}*/}
          {/*    <ImageModule*/}
          {/*      copy="Peel + Stick Wallpaper"*/}
          {/*      image={getImageUrl('homepage/rebrand/YRK_1000_MultiBambooGarden_03.jpg')}*/}
          {/*      url="/collections/peel-and-stick-wallpaper"*/}
          {/*      customImgixParameters={{*/}
          {/*        crop: 'focalpoint',*/}
          {/*        'fp-y': 0.6,*/}
          {/*        ar: '1.7:1'*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*)}*/}
          {hoveredItem === 'outdoor' && (
            <div className="wrapper-head-menu">
              {outdoorData.map((item, i) => {
                return (
                  <NavHoveredMenu
                    className="hovered-menu"
                    key={i}
                    item={item}
                  />
                );
              })}
              <ImageModule
                copy="Outdoor Living"
                image={getImageUrl('homepage/rebrand/davidtsay230512.Havenly.Brentwood.0043-v1.sunny_1.jpg')}
                url="/collections/outdoorliving"
                customImgixParameters={{
                  crop: 'focalpoint',
                  'fp-y': 0.5,
                  ar: '1.7:1'
                }}
              />
            </div>
          )}

          {hoveredItem === 'fabric' && (
            <div className="wrapper-head-menu">
              {fabricData.map((item, i) => {
                return (
                  <NavHoveredMenu
                    className="hovered-menu"
                    key={i}
                    item={item}
                  />
                );
              })}
              <ImageModule
                smallerCopy={true}
                copy="Designer-Loved Fabrics"
                image={getImageUrl('homepage/rebrand/FBTY_JadePeacockPark_1.jpg')}
                url="/collections/bestselling-fabric-by-the-yard"
                customImgixParameters={{
                  crop: 'focalpoint',
                  'fp-y': 0.5,
                  ar: '1.7:1'
                }}
              />
            </div>
          )}
          {hoveredItem === 'new' && (
            <div
              className="wrapper-head-menu"
              style={{ width: newData.length > 1 ? '820px' : '620px' }}
            >
              {newData.map((item, i) => {
                return (
                  <NavHoveredMenu
                    className="hovered-menu"
                    key={i}
                    item={item}
                  />
                );
              })}
              <ImageModule
                copy="New Arrivals"
                image={getImageUrl('homepage/rebrand/kyliefitts_theinside+interiordefine_veronica-vineway_9.jpg')}
                url="/collections/new-arrivals"
                customImgixParameters={{
                crop: 'focalpoint',
                  'fp-y': 0.85,
                  // 'fp-z': 1.12,
                  'fp-z': 1,
                ar: '1.7:1'
                }}
              />
            </div>
          )}
          {/*{hoveredItem === 'collaborations' ? (*/}
          {/*  <div className="wrapper-head-menu">*/}
          {/*    {collabData.map((item, i) => {*/}
          {/*      return (*/}
          {/*        <NavHoveredMenu*/}
          {/*          className="hovered-menu"*/}
          {/*          key={i}*/}
          {/*          item={item}*/}
          {/*        />*/}
          {/*      );*/}
          {/*    })}*/}
          {/*    <ImageModule*/}
          {/*      copy="CW Stockwell"*/}
          {/*      image={getImageUrl('nav/nav-images/kyliefitts_havenly_theinside_malibu_7.jpg')}*/}
          {/*      url="/collaborators/cw-stockwell"*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*) : (*/}
          {/*  ''*/}
          {/*)}*/}
          {hoveredItem === 'inspiration' ? (
            <div className="wrapper-head-menu">
              {inspirationData.map((item, i) => {
                return (
                  <NavHoveredMenu
                    className="hovered-menu"
                    key={i}
                    item={item}
                  />
                );
              })}
              <ImageModule
                smallerCopy={true}
                copy="Living Room Inspiration"
                image={getImageUrl('homepage/rebrand/kyliefitts_havenly_theinside_shelbynorwalk_231.jpg')}
                url="/theinside-irl?menu%5Brooms%5D=Living%20Room&page=1"
                customImgixParameters={{
                  crop: 'focalpoint',
                  'fp-y': 0.47,
                  ar: '1.7:1'
                }}
              />
            </div>
          ) : (
            ''
          )}
          {hoveredItem === 'swatches' ? (
            <div className="wrapper-head-menu">
              {swatchesData.map((item, i) => {
                return (
                  <NavHoveredMenu
                    className="hovered-menu"
                    key={i}
                    item={item}
                  />
                );
              })}
              <ImageModule
                copy="Start with a Swatch"
                image={getImageUrl('homepage/rebrand/start-swatch-11.jpg')}
                url="/fabric-swatches"
                customImgixParameters={{
                  crop: 'focalpoint',
                  'fp-y': 0.55,
                  ar: '1.7:1'
                }}
              />
            </div>
          ) : (
            ''
          )}
          {hoveredItem === 'trade' ? (
            <div className="wrapper-head-menu">
              {tradeData.map((item, i) => {
                return (
                  <NavHoveredMenu
                    className="hovered-menu"
                    key={i}
                    item={item}
                  />
                );
              })}
              <ImageModule
                smallerCopy={true}
                trade={true}
                copy="Apply for a Trade account"
                image={getImageUrl('homepage/rebrand/kyliefitts_theinside interiordefine_veronica-vineway_17.jpg')}
                url="/design-trade-services"
                customImgixParameters={{
                  crop: 'focalpoint',
                  'fp-y': 0.48,
                  'fp-z': 0.94,
                  ar: '1.7:1'
                }}
              />
            </div>
          ) : (
            ''
          )}
        </>
      )}
    </Wrapper>
  );
}

function CollapsedMenu({ items }) {
  return (
    <div>
      { items.map((item) => (
        <NavHoveredMenu
          className="hovered-menu"
          key={item.title}
          item={item}
        />
      ))}
    </div>
  )
}

export default FullHeadMenuDropdown;

